/**
 * i18n Configuration
 * Defines supported locales and default locale for Vetta
 *
 * MVP launches in English only. Architecture supports all 24 EU official languages.
 * Expansion to additional languages happens post-launch.
 *
 * Supported EU official languages (alphabetically):
 * Bulgarian, Croatian, Czech, Danish, Dutch, English, Estonian, Finnish, French,
 * German, Greek, Hungarian, Irish, Italian, Latvian, Lithuanian, Luxembourgish,
 * Maltese, Polish, Portuguese, Romanian, Slovak, Slovenian, Spanish, Swedish
 */

export const LOCALES = [
  'en', // English (MVP launch)
  'bg', // Bulgarian
  'hr', // Croatian
  'cs', // Czech
  'da', // Danish
  'nl', // Dutch (Netherlands)
  'nl-BE', // Dutch (Flemish / Belgium)
  'et', // Estonian
  'fi', // Finnish
  'fr', // French (France)
  'fr-BE', // French (Belgium)
  'de', // German
  'el', // Greek
  'hu', // Hungarian
  'ga', // Irish
  'it', // Italian
  'lv', // Latvian
  'lt', // Lithuanian
  'lb', // Luxembourgish
  'mt', // Maltese
  'pl', // Polish
  'pt', // Portuguese
  'ro', // Romanian
  'sk', // Slovak
  'sl', // Slovenian
  'es', // Spanish
  'sv', // Swedish
] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  bg: 'Български',
  hr: 'Hrvatski',
  cs: 'Čeština',
  da: 'Dansk',
  nl: 'Nederlands',
  'nl-BE': 'Nederlands',
  et: 'Eesti',
  fi: 'Suomi',
  fr: 'Français',
  'fr-BE': 'Français',
  de: 'Deutsch',
  el: 'Ελληνικά',
  hu: 'Magyar',
  ga: 'Gaeilge',
  it: 'Italiano',
  lv: 'Latviešu',
  lt: 'Lietuvių',
  lb: 'Lëtzebuergesch',
  mt: 'Malti',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  es: 'Español',
  sv: 'Svenska',
};

export const LOCALE_FLAGS: Record<Locale, string> = {
  en: '🇬🇧',
  bg: '🇧🇬',
  hr: '🇭🇷',
  cs: '🇨🇿',
  da: '🇩🇰',
  nl: '🇳🇱',
  'nl-BE': '🇧🇪',
  et: '🇪🇪',
  fi: '🇫🇮',
  fr: '🇫🇷',
  'fr-BE': '🇧🇪',
  de: '🇩🇪',
  el: '🇬🇷',
  hu: '🇭🇺',
  ga: '🇮🇪',
  it: '🇮🇹',
  lv: '🇱🇻',
  lt: '🇱🇹',
  lb: '🇱🇺',
  mt: '🇲🇹',
  pl: '🇵🇱',
  pt: '🇵🇹',
  ro: '🇷🇴',
  sk: '🇸🇰',
  sl: '🇸🇮',
  es: '🇪🇸',
  sv: '🇸🇪',
};
